import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TrPlannedCheckoutInputComponent } from './tr-planned-checkout-input.component';
import { TrVirtualKeyboardButtonModule } from '../tr-virtual-keyboard-button/tr-virtual-keyboard-button.module';
import { MoneyPipeModule } from '../../pipes';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TrVirtualKeyboardButtonModule,
        MoneyPipeModule,
    ],
    exports: [ TrPlannedCheckoutInputComponent ],
    declarations: [ TrPlannedCheckoutInputComponent ],
})
export class TrPlannedCheckoutInputModule {}
